
/* Design Wars Motion Pack (v11) */
document.addEventListener('DOMContentLoaded', () => {
  // Slide-in reveals (left/right alternating if not specified)
  const revealNodes = Array.from(document.querySelectorAll('.dw-reveal, .card-wrapper, .product-card-wrapper, .card'));
  const revealTargets = revealNodes
    .filter(el => !el.classList.contains('dw-no-reveal'))
    .map((el, i) => {
      if (!el.classList.contains('dw-reveal')) el.classList.add('dw-reveal');
      if (!el.classList.contains('dw-left') && !el.classList.contains('dw-right')) {
        el.classList.add(i % 2 === 0 ? 'dw-left' : 'dw-right');
      }
      return el;
    });

  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('dw-in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12, rootMargin: "0px 0px -10% 0px" });

  revealTargets.forEach((el, i) => {
    el.style.transitionDelay = Math.min(i * 45, 240) + 'ms';
    io.observe(el);
  });

  /**
   * Parallax (performance-safe)
   * - Disabled on mobile/touch and when user prefers reduced motion
   * - Throttled to rAF
   * - Only applies to the FIRST hero/banner media to avoid per-frame layout work
   */
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const isDesktop = window.matchMedia('(min-width: 990px)').matches;

  const media = (!prefersReduced && canHover && isDesktop)
    ? document.querySelector('.banner__media, .slideshow__media, .dw-parallax')
    : null;

  if (media) {
    let ticking = false;
    const update = () => {
      ticking = false;
      const rect = media.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top >= window.innerHeight) return;
      // Keep offset small to avoid large repaints.
      const offset = (rect.top - window.innerHeight / 2) * -0.04;
      media.style.transform = `translate3d(0, ${offset.toFixed(2)}px, 0)`;
    };
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  }

  // Product card hover tilt (desktop only)
  const cards = Array.from(document.querySelectorAll('.card-wrapper, .product-card-wrapper, .card'));
  if (canHover) {
    cards.forEach(card => {
      card.classList.add('dw-tilt');
      card.addEventListener('mousemove', (e) => {
        const r = card.getBoundingClientRect();
        const cx = r.left + r.width / 2;
        const cy = r.top + r.height / 2;
        const dx = (e.clientX - cx) / (r.width / 2);
        const dy = (e.clientY - cy) / (r.height / 2);
        card.style.setProperty('--dw-tilt-x', (dy * -6).toFixed(2) + 'deg');
        card.style.setProperty('--dw-tilt-y', (dx * 8).toFixed(2) + 'deg');
      });
      card.addEventListener('mouseleave', () => {
        card.style.setProperty('--dw-tilt-x', '0deg');
        card.style.setProperty('--dw-tilt-y', '0deg');
      });
    });
  }

  // NOTE: Header already has Shopify's StickyHeader logic.
  // Avoid adding extra scroll listeners here.
});
